import { render, staticRenderFns } from "./ConfigurazioniMagazzinoArticoliCategoriaListComponent.vue?vue&type=template&id=520b53d9"
import script from "./ConfigurazioniMagazzinoArticoliCategoriaListComponent.vue?vue&type=script&lang=js"
export * from "./ConfigurazioniMagazzinoArticoliCategoriaListComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports